var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user_color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04-Biller-Screen",
    transform: "translate(-802.000000, -306.000000)",
    fill: "#6C3964",
    fillRule: "nonzero",
    stroke: "#6C3964",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-user-4610470",
    transform: "translate(803.000000, 307.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,0.77307498 C6.02358014,0.77307498 0.77307498,6.02358014 0.77307498,12.5 C0.77307498,15.421177 1.84112723,18.0928412 3.6080591,20.1459551 L3.6080591,19.4588475 C3.6080591,15.9714404 6.43533052,13.1443494 9.92255719,13.1443494 L15.2059879,13.1443494 C18.693395,13.1443494 21.520486,15.9714404 21.520486,19.4588475 L21.520486,19.9937306 C23.2104712,17.9615898 24.2266995,15.3494173 24.2266995,12.5002255 C24.2266995,6.02380566 18.9761943,0.773300498 12.4997745,0.773300498 L12.5,0.77307498 Z M20.7476366,20.8364906 L20.7476366,19.4587122 C20.7476366,16.3983456 18.2667605,13.9172891 15.2062135,13.9172891 L9.92278271,13.9172891 C6.86241611,13.9172891 4.3813596,16.3981652 4.3813596,19.4587122 L4.3813596,20.962104 C6.4883723,22.9841867 9.34906545,24.2268348 12.5,24.2268348 C15.7155679,24.2268348 18.6291225,22.9325882 20.7476366,20.8364906 L20.7476366,20.8364906 Z M0,12.5 C0,5.59644945 5.59644945,0 12.5,0 C19.4035506,0 25,5.59644945 25,12.5 C25,19.4035506 19.4035506,25 12.5,25 C5.59644945,25 0,19.4035506 0,12.5 Z M12.3714549,3.60828462 C10.5209912,3.60828462 9.02075666,5.10851916 9.02075666,6.95898282 C9.02075666,8.80926607 10.5209912,10.3095006 12.3714549,10.3095006 C14.2217381,10.3095006 15.7219726,8.80926607 15.7219726,6.95898282 C15.7219726,5.10851916 14.2217381,3.60828462 12.3714549,3.60828462 L12.3714549,3.60828462 Z M8.24763657,6.95898282 C8.24763657,4.68143357 10.0939056,2.83516454 12.3714549,2.83516454 C14.6488237,2.83516454 16.4950927,4.68143357 16.4950927,6.95898282 C16.4950927,9.23635166 14.6488237,11.0826207 12.3714549,11.0826207 C10.0939056,11.0826207 8.24763657,9.23635166 8.24763657,6.95898282 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserColor);
export default __webpack_public_path__ + "static/media/user_color.8c4240ccb8348d3990d7deffe19726bc.svg";
export { ForwardRef as ReactComponent };